export const NO_SELECTION = '';
